import { useRegisterSW } from 'virtual:pwa-register/react'
import { useEffect } from 'react'
import { toast } from '@/store/feedbackStore'

/** Registers the service worker and offers a one-click reload when a new version is ready. */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    offlineReady: [offlineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, reg) {
      // check for updates every hour while the app stays open
      if (reg) setInterval(() => void reg.update(), 60 * 60 * 1000)
    },
  })
  useEffect(() => {
    if (offlineReady) toast('Folio is ready to work offline', 'success')
  }, [offlineReady])
  useEffect(() => {
    if (needRefresh)
      toast('A new version of Folio is available', 'info', {
        label: 'Update',
        run: () => void updateServiceWorker(true),
      })
  }, [needRefresh, updateServiceWorker])
  return null
}
